<template>
  <tender-form-label :key="index" :label="options.Name" :prop="options.Key" :rules="rules">
    <bear-select
      :key="time"
      v-model="form[options.Key]"
      :attrs="attrs"
      :options="options"
      :disabled="options.Disabled"
      @change="selectChangeHandle"></bear-select>
  </tender-form-label>
</template>
<script>
import BearSelect from "~@/select/src";
import { mixForFormItem } from "../../../js/mixins";
import utils from "../../../js/utils";
import tenderHook from "../../../js/hooks";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { tenderProjectConfig } from "@store/tender/modules/waterStore";
export default {
  name: "FormSelectBondBanks",
  mixins: [mixForFormItem],
  components: { BearSelect },
  data() {
    return {
      time: new Date().getTime(),
      fileLimitLength: 800,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapState(["selections"]),
  },
  watch: {
    "form.TRADE_CENTER": {
      handler(val, oldVal) {
        this.initBankOptions();
      },
    },
  },
  methods: {
    ...mapActions(["initBankOptions"]),
    init() {
      let { value, param, form = {}, options = {} } = this;
      this.$nextTick(() => {
        this.initBankOptions();
      });
    },

    selectChangeHandle(val) {
      let { form = {}, options = {}, properties } = this;
      let { Key, Refs = [], Options = [], OptionsFromStore } = options;
      let bondOption = this.selections[OptionsFromStore];
      this.form.MARGIN_BANK = "";
      this.form.MARGIN_NAME = "";
      this.form.MARGIN_NUMBER = "";
      this.form.BOND_BANKS = [];
      //重置选项
      if (val.length > 0) {
        this.bondSelectValueReset(val);
      }
      //重置选项
      if (!this.form.isBondOnline) return false;
      val.forEach((list) => {
        bondOption.forEach((item) => {
          if (item.NAME === list) {
            this.form.MARGIN_BANK = this.toSet("MARGIN_BANK", item, "NAME");
            this.form.MARGIN_NAME = this.toSet("MARGIN_NAME", item, "MAIN_NAME");
            this.form.MARGIN_NUMBER = "在线获取保证金子账号";
            this.form.BOND_BANKS.push(item);
          }
        });
      });

      this.doValidate();
    },
    bondSelectValueReset(val) {
      this.form.isBondOnline = true;
      if (val.length > 0) {
        //其他账户第几次被选中
        let custom_account_index = -1;
        val.forEach((account, index) => {
          if (tenderProjectConfig.CUSTOM_BANK_ACCOUNT.includes(account)) {
            custom_account_index = index;
          }
        });
        if (custom_account_index === val.length - 1) {
          //最后选中其他账户，清空在线保证金银行选项
          this.form.isBondOnline = false;
          if (val.length - 1 > 0) {
            //至少两个被选中
            val.splice(0, val.length - 1);
          }
        } else if (custom_account_index !== -1) {
          //在只有一个其他账户时，选中一个在线保证金银行
          val.splice(0, 1); //删除第一个其他账户
        }
        if (!this.form.isBondOnline) {
          return false;
        }
      }
      return true;
    },
    toSet(key, item, itemKey) {
      if (this.form[key] === "") {
        return item[itemKey];
      } else {
        return this.form[key] + "，" + item[itemKey];
      }
    },
  },
};
</script>
<style>
</style>